var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "svg-icon svg-close-icon",
      attrs: {
        "aria-hidden": "true",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        staticClass: "svg-icon__path",
        attrs: {
          d: "M13.683 11.99L19.6549 6.02C20.115 5.56 20.115 4.8 19.6549 4.34C19.2048 3.89 18.4145 3.89 17.9744 4.34L12.0025 10.31L6.03063 4.34C5.58049 3.89 4.80025 3.89 4.35011 4.34C4.12004 4.56 4 4.86 4 5.18C4 5.5 4.12004 5.8 4.35011 6.02L10.322 11.99L4.35011 17.96C4.12004 18.19 4 18.49 4 18.81C4 19.13 4.12004 19.43 4.35011 19.65C4.81025 20.11 5.57049 20.11 6.03063 19.65L12.0025 13.68L17.9744 19.65C18.1944 19.88 18.4945 20 18.8146 20C19.1347 20 19.4348 19.88 19.6549 19.65C20.115 19.19 20.115 18.43 19.6549 17.97L13.683 11.99Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }